/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import { parse, format } from 'date-fns';
import { id } from 'date-fns/locale';

export const convertToInputDateFormat = dateStr => {
  if (!dateStr) return dateStr;
  try {
    const parsedDate = parse(dateStr, 'dd/MM/yyyy', new Date());
    return format(parsedDate, 'yyyy-MM-dd');
  } catch (error) {
    return dateStr;
  }
};

export const convertToDisplayDateFormat = dateStr => {
  if (!dateStr) return '';
  try {
    const parsedDate = parse(dateStr, 'yyyy-MM-dd', new Date());
    return format(parsedDate, 'dd/MM/yyyy');
  } catch (error) {
    return '';
  }
};

export const convertToDisplayDateFormatddMMyyHH = dateStr => {
  if (!dateStr) return '';
  try {
    const parsedDate = parse(dateStr, 'yyyy-MM-dd HH:mm', new Date());
    return format(parsedDate, 'dd/MM/yyyy HH:mm');
  } catch (error) {
    return '';
  }
};

export const convertToInputDateFormatddMMyyHH = dateStr => {
  if (!dateStr) return '';
  try {
    const parsedDate = parse(dateStr, 'dd/MM/yyyy HH:mm', new Date());
    return format(parsedDate, 'yyyy-MM-dd HH:mm');
  } catch (error) {
    return '';
  }
};

export const convertDisplayddMMyyyy = dateStr => {
  if (!dateStr) return '';
  try {
    const parsedDate = new Date(dateStr);
    return format(parsedDate, 'dd/MM/yyyy');
  } catch (error) {
    return '';
  }
};

export const convertToDisplayDateFormatddmmmyyyy = dateStr => {
  if (!dateStr) return '';
  try {
    const parsedDate = new Date(dateStr); // bisa handle format ISO
    return format(parsedDate, 'd MMMM yyyy', { locale: id }); // contoh: 1 Maret 2025
  } catch (error) {
    return '';
  }
};

export const DateFormatmmmyyyy = dateStr => {
  if (!dateStr) return '';
  try {
    const parsedDate = new Date(dateStr); // bisa handle format ISO
    return format(parsedDate, 'MMMM yyyy', { locale: id }); // contoh: 1 Maret 2025
  } catch (error) {
    return '';
  }
};

export const dateFormat = () => {
  let d = new Date(),
    months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
  let h = d.getHours() % 12 || 12;
  let ampm = d.getHours() < 12 ? 'AM' : 'PM';
  return (
    d.getDate() +
    ' ' +
    months[d.getMonth()] +
    ', ' +
    d.getFullYear() +
    ', ' +
    h +
    ':' +
    d.getMinutes() +
    ' ' +
    ampm
  ).toString();
};

export const dateformate = e => {
  const dateString = e.toString().split(' ');
  let time = dateString[4];
  let H = +time.substr(0, 2);
  let h = H % 12 || 12;
  h = h <= 9 ? (h = '0' + h) : h;
  let ampm = H < 12 ? 'AM' : 'PM';
  time = h + time.substr(2, 3) + ' ' + ampm;
  const date = dateString[2] + ' ' + dateString[1] + ', ' + dateString[3];
  const orderDate = (date + ', ' + time).toString();
  setDate(orderDate);
};

export const dateFormatNow = () => {
  let d = new Date();
  return (d.getDate() + '/' + d.getMonth() + '/' + d.getFullYear()).toString();
};

export const dateFormatNows = () => {
  return format(new Date(), 'dd/MM/yyyy');
};

export const addDays = (date, days) => {
  var result = new Date(date);
  result.setDate(date.getDate() + days);
  return result;
};

export const formatDateToDDMMYYYY = isoDateString => {
  if (!isoDateString) return '';
  const date = new Date(isoDateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() starts from 0
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatDateToddmmyyhhmm = isoDateString => {
  if (!isoDateString) return '';
  const date = new Date(isoDateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() starts from 0
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export const formatDateTimeWithTimezone = (
  isoDateString,
  timezone = 'Asia/Jakarta'
) => {
  if (!isoDateString) return '';
  try {
    const date = new Date(isoDateString);

    // Format tanggal & waktu: "09 Jun 2026, 15:30:00"
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: timezone,
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).formatToParts(date);

    const get = type => parts.find(p => p.type === type)?.value || '';
    const formatted = `${get('day')} ${get('month')} ${get('year')}, ${get('hour')}:${get('minute')}:${get('second')}`;

    // Ambil offset timezone: "GMT+7" → "UTC+7"
    const tzParts = new Intl.DateTimeFormat('en', {
      timeZone: timezone,
      timeZoneName: 'shortOffset',
    }).formatToParts(date);
    const tzString = (
      tzParts.find(p => p.type === 'timeZoneName')?.value || ''
    ).replace('GMT', 'UTC');

    return `${formatted} (${tzString})`;
  } catch {
    return '';
  }
};

export const formatDateTimeWithTime = (
  isoDateString,
  timezone = 'Asia/Jakarta'
) => {
  if (!isoDateString) return '';
  try {
    const date = new Date(isoDateString);

    // Format tanggal & waktu: "09 Jun 2026, 15:30:00"
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: timezone,
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).formatToParts(date);

    const get = type => parts.find(p => p.type === type)?.value || '';
    const formatted = `${get('day')} ${get('month')} ${get('year')}`;

    return `${formatted} `;
  } catch {
    return '';
  }
};

export function getSafeInputDate(dateValue, convertFn) {
  if (!dateValue) return ''; // null / undefined / kosong
  const converted = convertFn(dateValue);
  if (converted === '1970-01-01') return ''; // default epoch dianggap kosong
  return converted;
}

// const formatEventDate = dateStr => {
//   if (!dateStr) return '-';
//   try {
//     const date = new Date(dateStr);
//     return format(date, 'EEEE, d MMMM yyyy', { locale: id });
//   } catch (error) {
//     return dateStr;
//   }
// };
